import type { DiagramSpec } from "../types"

/** Horizontal bands — layered architecture with nodes spread across each tier */
export const horizontalBands: DiagramSpec = {
  id: "horizontal-bands",
  name: "Bands: Brain Architecture",
  description: "Layered architecture with horizontal band groupings",
  layers: [
    { id: "frontend", name: "Frontend", color: "#6366f1" },
    { id: "middleware", name: "Middleware", color: "#f59e0b" },
    { id: "skills", name: "Skills", color: "#10b981" },
    { id: "data", name: "Data", color: "#ec4899" },
  ],
  nodes: [
    // Frontend tier
    { id: "telegram", label: "Telegram", layer: "frontend", rank: 0, description: "60+ chat groups" },
    { id: "slack", label: "Slack", layer: "frontend", rank: 0, description: "Workspace channels" },
    { id: "dashboard", label: "Dashboard", layer: "frontend", rank: 0, description: "React SPA" },
    { id: "vapi", label: "Voice (Vapi)", layer: "frontend", rank: 0, description: "Phone calls" },

    // Middleware tier
    { id: "router", label: "Message Router", layer: "middleware", rank: 1, description: "Routes to correct CC slot" },
    { id: "sessions", label: "Session Mgr", layer: "middleware", rank: 1, description: "Context & compaction" },
    { id: "crons", label: "Cron Engine", layer: "middleware", rank: 1, description: "60s interval scheduler" },

    // Skills tier
    { id: "api", label: "api-* Skills", layer: "skills", rank: 2, description: "TickTick, Monarch, Slack, etc." },
    { id: "wf", label: "wf-* Workflows", layer: "skills", rank: 2, description: "Daily flow, news feed, etc." },
    { id: "engine", label: "engine-* Systems", layer: "skills", rank: 2, description: "VidMax templates, bookkeeping" },
    { id: "kit", label: "kit-* Multi-tools", layer: "skills", rank: 2, description: "Creative, home, competitor" },

    // Data tier
    { id: "sqlite", label: "SQLite", layer: "data", rank: 3, description: "brain.db — jobs, LCM, messages" },
    { id: "brain-docs", label: "Brain Docs", layer: "data", rank: 3, description: "Markdown knowledge base" },
    { id: "r2", label: "R2 CDN", layer: "data", rank: 3, description: "File & image hosting" },
  ],
  edges: [
    { id: "e1", source: "telegram", target: "router" },
    { id: "e2", source: "slack", target: "router" },
    { id: "e3", source: "dashboard", target: "router" },
    { id: "e4", source: "vapi", target: "router" },
    { id: "e5", source: "router", target: "sessions" },
    { id: "e6", source: "crons", target: "router" },
    { id: "e7", source: "sessions", target: "api" },
    { id: "e8", source: "sessions", target: "wf" },
    { id: "e9", source: "sessions", target: "engine" },
    { id: "e10", source: "sessions", target: "kit" },
    { id: "e11", source: "api", target: "sqlite" },
    { id: "e12", source: "wf", target: "brain-docs" },
    { id: "e13", source: "engine", target: "r2" },
    { id: "e14", source: "wf", target: "sqlite" },
  ],
  views: [{ id: "main", name: "Architecture", layout: "TB" }],
  defaultView: "main",
  preferences: {
    nodeWidth: 200,
    rankSpacing: 140,
    nodeGap: 40,
    showLayerBands: true,
    edgeStyle: "smoothstep",
  },
}
